import { useState } from "react";
import { useTranslation } from "react-i18next";
import Reveal from "../components/Reveal";
import SectionHead from "../components/SectionHead";
import Recommender from "../components/tools/Recommender";
import Comparator from "../components/tools/Comparator";

const TABS = [
  { id: "recomendador", label: "tools.tabRecommender", head: "recommender" },
  { id: "comparador", label: "tools.tabComparator", head: "comparator" },
];

export default function ToolsSection({ onOpenProduct }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState(TABS[0].id);
  const activeTab = TABS.find((item) => item.id === tab) ?? TABS[0];

  return (
    <section className="fsg-section fsg-section--soft" id="herramientas">
      <div className="fsg-container">
        <SectionHead
          eyebrow={t("tools.eyebrow")}
          title={t("tools.title")}
          lead={t("tools.lead")}
        />

        <Reveal>
          <div
            className="fsg-chips"
            role="tablist"
            aria-label={t("tools.eyebrow")}
            style={{ marginBottom: "var(--fsg-s-5)" }}
          >
            {TABS.map((item) => (
              <button
                key={item.id}
                type="button"
                role="tab"
                id={`tab-${item.id}`}
                aria-selected={tab === item.id}
                aria-controls={`panel-${item.id}`}
                className="fsg-chip"
                onClick={() => setTab(item.id)}
              >
                {t(item.label)}
              </button>
            ))}
          </div>

          <div
            className="fsg-tool"
            role="tabpanel"
            id={`panel-${activeTab.id}`}
            aria-labelledby={`tab-${activeTab.id}`}
          >
            <div className="fsg-tool__head">
              <div>
                <h3>{t(`${activeTab.head}.title`)}</h3>
                <p>{t(`${activeTab.head}.subtitle`)}</p>
              </div>
            </div>

            <div className="fsg-tool__body">
              {tab === "recomendador" && (
                <Recommender onOpenProduct={onOpenProduct} />
              )}
              {tab === "comparador" && <Comparator />}
            </div>

            <div className="fsg-tool__foot">
              <p className="fsg-hint" style={{ maxWidth: "78ch" }}>
                {t("tools.disclaimer")}
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
